export {default as voronoi} from './src/Voronoi';



// WEBPACK FOOTER //
// ./~/vega-voronoi/index.js